/**
 * useContactStats.js — Global contact count/breakdown hook
 *
 * Derives counts from cached useContacts() data — zero extra API calls.
 * Import anywhere in the app to get contact totals + type breakdowns.
 */

import { useMemo } from 'react';
import { useContacts } from './useContacts';

export function useContactStats() {
  const { data: allContacts = [], isLoading } = useContacts();

  const stats = useMemo(() => {
    let clients = 0, crew = 0, vendors = 0;
    for (const c of allContacts) {
      if (c.type === 'client') clients++;
      else if (c.type === 'crew') crew++;
      else if (c.type === 'vendor') vendors++;
    }
    return { total: allContacts.length, clients, crew, vendors };
  }, [allContacts]);

  return { ...stats, isLoading };
}
